<template>
  <div class="add-lead-block panel">
    <h4>Ajout d'un lead</h4>
    <hr>
    <notifications v-if="is_any_errors"
                   :errors="errors"
                   @close-error="reset_error($event)"
                   >
    </notifications>
    <div class="row">
      <div class="col-md-4">
        <h5>Coordonnées du LEAD</h5>

        <div class="form-group">
          <label>Raison sociale</label>
          <custom-text :field="fields[9]"
                       :value="fields[9].value"
                       :field_idx="9"
                       @field-updated="updateInternalData($event, 'company_name')">
          </custom-text>
        </div>

        <div class="form-group">
          <label>Civilité</label>
          <custom-select :field="fields[2]"
                         :value="fields[2].value"
                         :field_idx="2"
                         @field-updated="updateInternalData($event, 'civility')">
          </custom-select>
        </div>

        <div class="form-group">
          <label>Nom</label>
          <custom-text :field="fields[3]"
                       :value="fields[3].value"
                       :field_idx="3"
                       @field-updated="updateInternalData($event, 'last_name')">
          </custom-text>
        </div>

        <div class="form-group">
          <label>Prénom</label>
          <custom-text :field="fields[4]"
                       :value="fields[4].value"
                       :field_idx="4"
                       @field-updated="updateInternalData($event, 'first_name')">
          </custom-text>
        </div>

        <div class="form-group">
          <label>Email</label>
          <custom-text :field="fields[5]"
                       :value="fields[5].value"
                       :field_idx="5"
                       @field-updated="updateInternalData($event, 'email')">
          </custom-text>
        </div>

        <div class="form-group">
          <label>Téléphone</label>
          <custom-text :field="fields[6]" 
                       :value="fields[6].value"
                       :field_idx="6"
                       @field-updated="updateInternalData($event, 'phone')">
          </custom-text>
        </div>
      </div>

      <div class="col-md-4">
        <h5>Associer à un client/prospect existant</h5>
        <div class="form-group">
          <label>Client</label>
          <search-and-select :initial-value="null" 
            :search-config="newLeadCustomerSearchConfig"
            :get-option-label="getCustomerNameWithRepresentativeAndErpId"
            @field-updated="updateInternalData($event, 'customer')">
          </search-and-select>
        </div>
        <div v-if="have_rights">
          <h5>Agence responsable de la relance</h5>
          <div class="form-group">
            <label>Agence</label>
            <custom-select :field="fields[0]" 
                           :value="fields[0].value" 
                           :field_idx="0"
                           @field-updated="updateInternalData($event, 'agency')">
            </custom-select>
          </div>
        </div>
        <div class="form-group" >
          <label>LEAD créé par : (si Assistant(e), indiquer votre nom. Sinon laisser vide):</label>
          <custom-text :field="fields[1]" 
                       :value="fields[1].value"
                       :field_idx="1"
                       @field-updated="updateInternalData($event, 'author')">
          </custom-text>
        </div>

      </div>

      <div class="col-md-4">
        <h5>Complément</h5>
        <div class="form-group">
          <label>Informations complémentaires</label>
          <custom-text-area :field="fields[7]"
                            :value="fields[7].value"
                            :field_idx="7"
                            @field-updated="updateInternalData($event, 'complement')">
          </custom-text-area>
        </div>
        <div class="form-group">
          <label>Comment nous a-t-il connu ?</label>
          <custom-select :field="fields[8]"
                         :value="fields[8].value"
                         :field_idx="8"
                         @field-updated="updateInternalData($event, 'origin_supplement')">
          </custom-select>
        </div>
        <!-- <div class="form-group">
          <label>Message :</label>
          <custom-select :field="fields[9]" 
                         :value="fields[9].value"
                         :field_idx="9"
                         @field-updated="updateInternalData($event, 'origin_message')">
          </custom-select>
        </div> -->
      </div>
    </div>
    <div class="row" v-if="!is_fetching">
      <div class="pull-right operations">
         <button class="btn btn-success" @click="handleAdd" v-if="readyForAdd">Ajouter</button>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "components/Form/Select2"
import CustomText from "components/Forms/Elements/Text"
import SearchAndSelect from "components/Forms/Elements/SearchAndSelect"
import CustomSelect from "components/Forms/Elements/Select"
import CustomTextArea from "components/Forms/Elements/TextArea"
import Notifications from "./Notifications"
import {mapGetters, mapActions, mapState} from "vuex"
import customerMixin from 'mixins/customer'
import searchMixin from 'mixins/search'
import api from '../../../client/store/api'

export default {
  name:"CRMAddLead",

  components:{
    Select2,
    Notifications,
    CustomText,
    SearchAndSelect,
    CustomSelect,
    CustomTextArea
  },

  mixins: [customerMixin, searchMixin],

  data () {
    return {
      selected_customer:null,
      selected_agency:null,
      selected_leadable_type: null,
      selected_leadable_id: null,
      email_entry:"",
      phone_entry:"",
      supplement:"",
      origin_supplement_key: null,
      options_origins:[],
      author:"",
      company_name:"",
      first_name:"",
      last_name:"",
      selected_civility:null
    }
  },

  methods:{
    ...mapActions("crm", [
        "create_a_lead", "fetch_customers", "set_fetching_state", "reset_customers",
        "reset_errors", "fetch_all_leads", "reset_error", "fetchCrmRelatedUserGroups"
      ]),

    reset_data() {
      this.reset_errors()
      this.search_customer = ""
      this.email_entry = ""
      this.phone_entry = ""
      this.supplement = ""
      this.origin_supplement_key = null
      this.selected_agency = null
      this.selected_leadable_type = null
      this.selected_leadable_id = null
      this.author = ""
      this.selected_civility = null
      this.$emit('close')
    },

    handleAdd()
    {
      let params = {
        contact_email:this.email_entry,
        contact_phone:this.phone_entry,
        contact_civility:this.selected_civility,
        contact_company_name:this.company_name,
        contact_first_name:this.first_name,
        contact_last_name:this.last_name,
        contact_supplement:this.supplement,
        customer_id:this.selected_customer ? this.selected_customer.id : null,
        author:this.author,
        origin_supplement_key:this.origin_supplement_key,
        leadable_id:this.selected_leadable_id,
        leadable_type:this.selected_leadable_type
      }
      this.reset_errors()
      this.set_fetching_state(true)
      this.create_a_lead(params)
          .then(() => {
            if (!this.is_any_errors)
              this.$router.push({name:"lead", params:{id:this.last_added_lead.id}})
            else {
              this.set_fetching_state(false)
            }
          })
      this.set_fetching_state(false)
    },

    scrollToErrors (scrollTop = 0) {
      const $body = $('body, html')
      if (this.scrolling) {
        $body.stop()
        this.scrolling = false
      }
      this.scrolling = true
      $body.animate({ scrollTop }, 800,
        _ => this.scrolling = false)
    },

    updateInternalData(event, flag)
    {
      if (flag === "customer")
        this.selected_customer = event
      else if (flag == "agency") {
        let selectedAgency = event.new_value.value
        // Agency (now) useless data
        this.selected_agency = selectedAgency
        // Leadable
        if (selectedAgency != null) {
          let leadableArray = selectedAgency.split(".")

          if (leadableArray.length != 2) {
            this.$store.state.crm.errors.push([{message: "Une erreur s'est produite, merci de rafraîchir la page avant de réessayer"}])

            return false
          }

          this.selected_leadable_type = leadableArray[0]
          this.selected_leadable_id = leadableArray[1]
        }
      }
      else if (flag === "author") {
        this.author = event.new_value
      }
      else if (flag === "civility") {
        this.selected_civility = event.new_value.value
      }
      else if (flag === "company_name") {
        this.company_name = event.new_value
      }
      else if (flag === "first_name") {
        this.first_name = event.new_value
      }
      else if (flag === "last_name") {
        this.last_name = event.new_value
      }
      else if (flag === "email") {
        this.email_entry = event.new_value
      }
      else if (flag === "phone") {
        this.phone_entry = event.new_value
      }
      else if (flag === "origin_supplement") {
        this.origin_supplement_key = event.new_value.value
      } else if (flag === "complement") {
        this.supplement = event.new_value
      }
      // console.warn(flag + ' ' + JSON.stringify(event))
    },

    fetchOriginSupplementKeys() {
      const params = {
        active: 1,
        type: "customer_origin"
      }

      api.fetchSettings(params)
        .then((response) => this.options_origins = response.data.settings)
        .catch((error) => state.errors.push(error.response.data.errors))
    },
  },

  computed : {
    ...mapGetters("crm", ["is_fetching","customers_as_options","is_any_errors", "errors", "customers", "userGroups"]),
    ...mapGetters("customers", ["selectAgenciesList"]),
    ...mapState("crm", ["last_added_lead"]),
    ...mapState(["user"]),
    ...mapState(["agencies"]),

    readyForAdd() {
      return ((this.email_entry.length > 0 || this.phone_entry.length > 0))
    },

    have_rights(){
      var res = true
      var found = _.find(this.user.me.roles, role => role.name == "agency")
      if (this.user.me.roles.length == 1 && found)
        {
          res = false
        }
      return res
    },

    optionsList() {
      // Default option
      let defaultOption = _.assign({}, {
        id: null,
        text: "Aucune"
      })

      // Formatted user groups
      let userGroupsOptions = _.map(this.userGroups, (userGroup) => (
        {
          id: "user_group." + userGroup.id,
          text: userGroup.display_name
        }
      ))

      // Formatted agencies
      let agenciesOptions = _.map(this.agencies, (agency) => (
        {
          id: "agency." + agency.id,
          text: agency.name
        }
      ))

      return _.concat(defaultOption, userGroupsOptions, agenciesOptions)
    },

    getOrigins() {
        let origins = _.map(this.options_origins, (origin) => (
            {
                id: origin.key,
                text: origin.value
            }
        ))

        return origins;
    },

    fields()
    {
      let v =
      [
        {values:this.optionsList, multiple:false, placeholder:"", disabled:this.is_fetching, idx:0, required:false, value:this.selected_agency, label:"Agence",type:"select"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:1, required:false, value:"", label:"",type:"text"},
        {values:[
          {id:"mr", text:"M."},
          {id:"mrs", text:"Mme."}
        ], multiple:false, placeholder:"", disabled:this.is_fetching, idx:2, required:false, value:this.selected_civility, label:"",type:"select"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:3, required:false, value:this.last_name, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:4, required:false, value:this.first_name, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:5, required:false, value:this.email_entry, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:6, required:false, value:this.phone_entry, label:"",type:"text"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:7, required:false, value:this.supplement, label:"",type:"textarea"},
        {values:this.getOrigins, multiple:false, placeholder:"", disabled:this.is_fetching, idx:8, required:false, value:this.origin_supplement_key, label:"",type:"select"},
        {values:[], multiple:false, placeholder:"", disabled:this.is_fetching, idx:9, required:false, value:this.company_name, label:"",type:"textarea"},
      ]
      return v
    }
  },

  watch :{
    search_customer : function () {
      this.reset_customers()
      this.debounced_search_customer()
    },

    is_any_errors: function (newv, oldv) {
      if (newv)
        this.scrollToErrors()
    },

    selected_customer : function (newv, oldv) {
      this.company_name = ""
      this.first_name = ""
      this.last_name = ""
      this.email_entry = ""
      this.phone_entry = ""
      this.selected_civility = null
      if (newv)
      {
        let selected_candidate = newv
        if (selected_candidate && selected_candidate.main_representative)
        {
          if (selected_candidate.buyers.length > 0 && selected_candidate.buyers[0].email)
            this.email_entry = selected_candidate.buyers[0].email
          if (selected_candidate.name)
            this.company_name = selected_candidate.name
          if (selected_candidate.main_representative.first_name)
            this.first_name = selected_candidate.main_representative.first_name
          if (selected_candidate.main_representative.last_name)
            this.last_name = selected_candidate.main_representative.last_name
          if (selected_candidate.main_representative.phone )
            this.phone_entry = selected_candidate.main_representative.phone
          if (selected_candidate.main_representative.mobile_phone && !this.phone_entry )
            this.phone_entry = selected_candidate.main_representative.mobile_phone
          if (selected_candidate.main_representative.civility)
            this.selected_civility = selected_candidate.main_representative.civility
          this.$forceUpdate()
        }
      }

    }
  },

  mounted() {
    this.fetchCrmRelatedUserGroups()

    this.fetchOriginSupplementKeys()

    this.debounced_error_clean = _.debounce(this.reset_errors, 3500)
  }
}
</script>
<style scoped>
.add-lead-block {
  padding:20px;
}
.operations {
  /*margin:20px;*/
}
.search_button {
  /*margin-top:25px;*/
}
.search-button-container {
  /*display: flex;
  justify-content: center;*/
}
</style>



// WEBPACK FOOTER //
// client/components/CRM/AddLead.vue